"use client"

import { ErrorMessage } from "@/app/error"
import { ProfileBlockchainFilters } from "@/app/profiles/profile-blockchain-filters"
import { reatomComponent } from "@reatom/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import {
  ActivityTableSkeleton,
  ProfileActivityTableReatom,
} from "./activity-table.reatom"

export const ActivityViewReatom = reatomComponent(() => {
  return (
    <ErrorBoundary
      fallback={
        <div className="flex h-full flex-col items-center justify-center">
          <ErrorMessage />
        </div>
      }
    >
      <div className="flex flex-wrap items-center gap-4 md:flex-nowrap md:justify-end">
        <ProfileBlockchainFilters />
      </div>
      <Suspense fallback={<ActivityTableSkeleton />}>
        <ProfileActivityTableReatom />
      </Suspense>
    </ErrorBoundary>
  )
})
